export function addDataLayer(dataLayer) {
  const url = window?.location?.origin || undefined
  const data = {
    eventLabel: url,
    ...dataLayer,
  }

  window?.dataLayer?.push(data)
}
